import { Common } from '~/models/common';
import { Reviews } from '~/models/reviews';
import { ReviewsGroup } from '~/models/reviews-group';

export const reviewsService = {
	fetch: async (isVideo: boolean = false): Promise<Reviews.Model[]> => {
		const params = {
			filter: {
				status: Common.Status.PUBLISHED,
				...(isVideo ? { isVideo: true } : { isVideo: false }),
			},
			fields: ['*', 'photo.*', 'group.*'],
		};

		try {
			const response = await $fetch<Reviews.Model[]>(Reviews.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch Reviews:', error);

			return [];
		}
	},

	fetchGroups: async (): Promise<ReviewsGroup.Model[]> => {
		const params = {
			filter: {
				status: Common.Status.PUBLISHED,
			},
			fields: ['*'],
		};

		try {
			const response = await $fetch<ReviewsGroup.Model[]>(ReviewsGroup.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch ReviewsGroup:', error);

			return [];
		}
	},
};
